import { Link, Route, Routes } from "react-router-dom";

import { BillingReturn } from "./components/BillingReturn";
import { ImageViewerProvider } from "./components/media/ImageViewer";
import { LoginPage } from "./pages/LoginPage";
import { ProjectsPage } from "./pages/ProjectsPage";
import { WorkspacePage } from "./pages/WorkspacePage";

function NotFoundPage() {
  return (
    <main
      style={{
        minHeight: "100dvh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 10,
        padding: "0 24px",
        textAlign: "center",
      }}
    >
      <p className="dp-label" style={{ letterSpacing: ".3em" }}>
        404
      </p>
      <h1
        style={{
          margin: 0,
          fontFamily: "var(--serif)",
          fontSize: 32,
          fontWeight: 500,
          letterSpacing: ".03em",
          color: "var(--ink)",
        }}
      >
        这个页面不存在
      </h1>
      <p style={{ margin: 0, fontSize: 12, color: "var(--ink-3)" }}>
        链接可能已经失效，回到项目列表继续。
      </p>
      <Link to="/" className="dp-btn primary" style={{ marginTop: 8 }}>
        回到项目列表
      </Link>
    </main>
  );
}

/**
 * 只包含路由：`main.tsx` 套 BrowserRouter，测试套 MemoryRouter。
 *
 * `ImageViewerProvider` 放在路由外面：任何页面（资料库、故事板、世界节点…）都能
 * `useImageViewer().open()`，浮层 portal 到 body，不被业务容器的 overflow / transform 裁掉。
 */
export function AppRoutes() {
  return (
    <ImageViewerProvider>
      <BillingReturn />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<ProjectsPage />} />
        <Route path="/p/:projectId" element={<WorkspacePage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </ImageViewerProvider>
  );
}
